import { render, staticRenderFns } from "./CourseSteps.vue?vue&type=template&id=fc6be22c&scoped=true&"
import script from "./CourseSteps.vue?vue&type=script&lang=js&"
export * from "./CourseSteps.vue?vue&type=script&lang=js&"
import style0 from "./CourseSteps.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CourseSteps.vue?vue&type=style&index=1&id=fc6be22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6be22c",
  null
  
)

export default component.exports